export interface Chapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  description: string;
  categories: string[];
  status: '连载' | '完结';
  rating: number;
  views: number;
  updatedAt: string;
  chapters: Chapter[];
  featured?: boolean;
}

export const comics: Comic[] = [
  {
    id: 'comic-001',
    title: '深渊之光',
    author: '李星河',
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20manga%20cover%20illustration%20of%20a%20fantasy%20adventure%2C%20a%20young%20warrior%20holding%20a%20glowing%20sword%20in%20a%20dark%20abyss%2C%20dramatic%20lighting%2C%20detailed%20anime%20art%20style%2C%20clean%20simple%20background%20with%20subtle%20gradient%2C%20professional%20manga%20cover%20composition&width=400&height=560&seq=manga-cover-001&orientation=portrait',
    description: '在无尽的深渊中，少年林逸偶然获得了一束神秘的光芒。这束光不仅照亮了他的前路，更揭开了尘封千年的秘密。跟随林逸的脚步，探索深渊之下被遗忘的文明，与各路强者交锋，一步步揭开世界的真相。',
    categories: ['hanman', 'wanjie'],
    status: '连载',
    rating: 9.2,
    views: 1258000,
    updatedAt: '2026-08-03',
    featured: true,
    chapters: [
      { id: 'ch-001-1', title: '第1话 深渊之始', number: 1, updatedAt: '2026-01-15' },
      { id: 'ch-001-2', title: '第2话 光芒降临', number: 2, updatedAt: '2026-01-22' },
      { id: 'ch-001-3', title: '第3话 初遇同伴', number: 3, updatedAt: '2026-01-29' },
      { id: 'ch-001-4', title: '第4话 地下迷宫', number: 4, updatedAt: '2026-02-05' },
      { id: 'ch-001-5', title: '第5话 暗影突袭', number: 5, updatedAt: '2026-02-12' },
      { id: 'ch-001-6', title: '第6话 远古遗迹', number: 6, updatedAt: '2026-02-19' },
      { id: 'ch-001-7', title: '第7话 遗迹守卫', number: 7, updatedAt: '2026-02-26' },
      { id: 'ch-001-8', title: '第8话 突破重围', number: 8, updatedAt: '2026-03-04' },
      { id: 'ch-001-9', title: '第9话 深渊领主', number: 9, updatedAt: '2026-03-11' },
      { id: 'ch-001-10', title: '第10话 光的意志', number: 10, updatedAt: '2026-03-18' },
      { id: 'ch-001-11', title: '第11话 觉醒之力', number: 11, updatedAt: '2026-03-25' },
      { id: 'ch-001-12', title: '第12话 同伴集结', number: 12, updatedAt: '2026-04-01' },
      { id: 'ch-001-13', title: '第13话 最终防线', number: 13, updatedAt: '2026-04-08' },
      { id: 'ch-001-14', title: '第14话 决战时刻', number: 14, updatedAt: '2026-04-15' },
      { id: 'ch-001-15', title: '第15话 新世界', number: 15, updatedAt: '2026-04-22' },
      { id: 'ch-001-16', title: '第16话 异界之门', number: 16, updatedAt: '2026-04-29' },
      { id: 'ch-001-17', title: '第17话 异界探索', number: 17, updatedAt: '2026-05-06' },
      { id: 'ch-001-18', title: '第18话 命运交汇', number: 18, updatedAt: '2026-05-13' },
      { id: 'ch-001-19', title: '第19话 星辰之约', number: 19, updatedAt: '2026-05-20' },
      { id: 'ch-001-20', title: '第20话 终焉序曲', number: 20, updatedAt: '2026-05-27' },
      { id: 'ch-001-21', title: '第21话 破晓', number: 21, updatedAt: '2026-06-03' },
      { id: 'ch-001-22', title: '第22话 黎明之前', number: 22, updatedAt: '2026-06-10' },
      { id: 'ch-001-23', title: '第23话 光与暗', number: 23, updatedAt: '2026-06-17' },
      { id: 'ch-001-24', title: '第24话 传承', number: 24, updatedAt: '2026-06-24' },
      { id: 'ch-001-25', title: '第25话 新的征程', number: 25, updatedAt: '2026-07-01' },
    ],
  },
  {
    id: 'comic-002',
    title: '星域猎手',
    author: '陈墨白',
    cover: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20manga%20cover%20featuring%20a%20futuristic%20bounty%20hunter%20in%20sleek%20armor%20standing%20on%20a%20spaceship%20deck%2C%20stars%20and%20nebula%20in%20background%2C%20dynamic%20pose%2C%20clean%20anime%20art%20style%2C%20simple%20gradient%20background%2C%20professional%20composition&width=400&height=560&seq=manga-cover-002&orientation=portrait',
    description: '公元3024年，人类文明已遍布银河系。赏金猎人苏晚驾驶着她的飞船"星尘号"，穿梭于各个星球之间，追捕最危险的星际罪犯。在一次看似普通的任务中，她意外卷入了一场足以颠覆银河秩序的阴谋……',
    categories: ['hanman'],
    status: '连载',
    rating: 9.5,
    views: 2350000,
    updatedAt: '2026-08-02',
    featured: true,
    chapters: [
      { id: 'ch-002-1', title: '第1话 星际猎人', number: 1, updatedAt: '2026-02-01' },
      { id: 'ch-002-2', title: '第2话 赏金任务', number: 2, updatedAt: '2026-02-08' },
      { id: 'ch-002-3', title: '第3话 太空追击', number: 3, updatedAt: '2026-02-15' },
      { id: 'ch-002-4', title: '第4话 黑洞边缘', number: 4, updatedAt: '2026-02-22' },
      { id: 'ch-002-5', title: '第5话 神秘信号', number: 5, updatedAt: '2026-03-01' },
      { id: 'ch-002-6', title: '第6话 废弃空间站', number: 6, updatedAt: '2026-03-08' },
      { id: 'ch-002-7', title: '第7话 异形生物', number: 7, updatedAt: '2026-03-15' },
      { id: 'ch-002-8', title: '第8话 生死一线', number: 8, updatedAt: '2026-03-22' },
      { id: 'ch-002-9', title: '第9话 联盟介入', number: 9, updatedAt: '2026-03-29' },
      { id: 'ch-002-10', title: '第10话 幕后黑手', number: 10, updatedAt: '2026-04-05' },
      { id: 'ch-002-11', title: '第11话 真相浮现', number: 11, updatedAt: '2026-04-12' },
      { id: 'ch-002-12', title: '第12话 叛变', number: 12, updatedAt: '2026-04-19' },
      { id: 'ch-002-13', title: '第13话 绝境', number: 13, updatedAt: '2026-04-26' },
      { id: 'ch-002-14', title: '第14话 援军', number: 14, updatedAt: '2026-05-03' },
      { id: 'ch-002-15', title: '第15话 反击', number: 15, updatedAt: '2026-05-10' },
      { id: 'ch-002-16', title: '第16话 决战星域', number: 16, updatedAt: '2026-05-17' },
      { id: 'ch-002-17', title: '第17话 和平曙光', number: 17, updatedAt: '2026-05-24' },
      { id: 'ch-002-18', title: '第18话 新的威胁', number: 18, updatedAt: '2026-05-31' },
      { id: 'ch-002-19', title: '第19话 远古文明', number: 19, updatedAt: '2026-06-07' },
      { id: 'ch-002-20', title: '第20话 遗物之谜', number: 20, updatedAt: '2026-06-14' },
    ],
  },
  {
    id: 'comic-003',
    title: '樱花庄的日常',
    author: '铃木花子',
    cover: 'https://readdy.ai/api/search-image?query=A%20slice%20of%20life%20manga%20cover%20showing%20a%20group%20of%20cute%20high%20school%20students%20in%20school%20uniforms%20under%20cherry%20blossom%20trees%2C%20warm%20spring%20atmosphere%2C%20heartwarming%20scene%2C%20clean%20anime%20style%2C%20soft%20pastel%20colors%2C%20simple%20background&width=400&height=560&seq=manga-cover-003&orientation=portrait',
    description: '东京郊外，有一栋名为"樱花庄"的老式公寓。这里住着一群性格各异的高中生——天才画家、热血运动员、学霸少女和神秘的转校生。他们在这里度过了青春最美好的时光，有欢笑，有泪水，有成长。这是一部温暖治愈的校园日常漫画。',
    categories: ['riman'],
    status: '连载',
    rating: 9.7,
    views: 3850000,
    updatedAt: '2026-08-03',
    featured: true,
    chapters: [
      { id: 'ch-003-1', title: '第1话 樱花盛开的季节', number: 1, updatedAt: '2025-06-01' },
      { id: 'ch-003-2', title: '第2话 新室友', number: 2, updatedAt: '2025-06-08' },
      { id: 'ch-003-3', title: '第3话 第一次社团活动', number: 3, updatedAt: '2025-06-15' },
      { id: 'ch-003-4', title: '第4话 夏日烟火', number: 4, updatedAt: '2025-06-22' },
      { id: 'ch-003-5', title: '第5话 海边合宿', number: 5, updatedAt: '2025-06-29' },
      { id: 'ch-003-6', title: '第6话 学园祭前夜', number: 6, updatedAt: '2025-07-06' },
      { id: 'ch-003-7', title: '第7话 学园祭当天', number: 7, updatedAt: '2025-07-13' },
      { id: 'ch-003-8', title: '第8话 秋日远足', number: 8, updatedAt: '2025-07-20' },
      { id: 'ch-003-9', title: '第9话 文化差异', number: 9, updatedAt: '2025-07-27' },
      { id: 'ch-003-10', title: '第10话 圣诞惊喜', number: 10, updatedAt: '2025-08-03' },
      { id: 'ch-003-11', title: '第11话 新年参拜', number: 11, updatedAt: '2025-08-10' },
      { id: 'ch-003-12', title: '第12话 情人节', number: 12, updatedAt: '2025-08-17' },
      { id: 'ch-003-13', title: '第13话 毕业季', number: 13, updatedAt: '2025-08-24' },
      { id: 'ch-003-14', title: '第14话 新的开始', number: 14, updatedAt: '2025-08-31' },
      { id: 'ch-003-15', title: '第15话 春又来', number: 15, updatedAt: '2025-09-07' },
    ],
  },
  {
    id: 'comic-004',
    title: '修仙大佬在现代',
    author: '风清扬',
    cover: 'https://readdy.ai/api/search-image?query=A%20cultivation%20manhua%20cover%20featuring%20a%20powerful%20immortal%20cultivator%20in%20traditional%20Chinese%20robes%20standing%20in%20a%20modern%20city%20street%2C%20contrast%20between%20ancient%20and%20modern%2C%20dramatic%20composition%2C%20clean%20manhua%20art%20style%2C%20simple%20gradient%20background&width=400&height=560&seq=manga-cover-004&orientation=portrait',
    description: '修仙界第一强者云天在渡劫失败后，意外穿越到了现代都市。在这个没有灵气的世界，他凭借一身修为混得风生水起。从送外卖到成为商界大亨，从被嘲笑到万人敬仰，看修仙大佬如何在现代都市书写传奇！',
    categories: ['guoman'],
    status: '完结',
    rating: 9.0,
    views: 5120000,
    updatedAt: '2026-06-15',
    chapters: [
      { id: 'ch-004-1', title: '第1话 天劫降临', number: 1, updatedAt: '2025-01-01' },
      { id: 'ch-004-2', title: '第2话 穿越现代', number: 2, updatedAt: '2025-01-08' },
      { id: 'ch-004-3', title: '第3话 初识都市', number: 3, updatedAt: '2025-01-15' },
      { id: 'ch-004-4', title: '第4话 第一桶金', number: 4, updatedAt: '2025-01-22' },
      { id: 'ch-004-5', title: '第5话 灵气复苏', number: 5, updatedAt: '2025-01-29' },
      { id: 'ch-004-6', title: '第6话 收徒', number: 6, updatedAt: '2025-02-05' },
      { id: 'ch-004-7', title: '第7话 商界风云', number: 7, updatedAt: '2025-02-12' },
      { id: 'ch-004-8', title: '第8话 隐世家族', number: 8, updatedAt: '2025-02-19' },
      { id: 'ch-004-9', title: '第9话 古武对决', number: 9, updatedAt: '2025-02-26' },
      { id: 'ch-004-10', title: '第10话 昆仑秘境', number: 10, updatedAt: '2025-03-05' },
      { id: 'ch-004-11', title: '第11话 远古传承', number: 11, updatedAt: '2025-03-12' },
      { id: 'ch-004-12', title: '第12话 飞升之路', number: 12, updatedAt: '2025-03-19' },
      { id: 'ch-004-13', title: '第13话 最终决战', number: 13, updatedAt: '2025-03-26' },
      { id: 'ch-004-14', title: '第14话 回归仙界（大结局）', number: 14, updatedAt: '2025-04-02' },
    ],
  },
  {
    id: 'comic-005',
    title: '恶魔校草的契约',
    author: '金美英',
    cover: 'https://readdy.ai/api/search-image?query=A%20romance%20manga%20cover%20showing%20a%20handsome%20male%20student%20with%20dark%20aura%20and%20a%20shy%20female%20student%2C%20romantic%20tension%2C%20rose%20petals%20floating%2C%20dramatic%20love%20story%20vibe%2C%20clean%20anime%20art%20style%2C%20dark%20elegant%20background&width=400&height=560&seq=manga-cover-005&orientation=portrait',
    description: '转学生林小鹿第一天就惹上了全校最危险的人物——校草韩辰逸。为了不被退学，她被迫签下一份"恋爱契约"，成为他的假女友。但在这场契约游戏中，真假感情开始模糊界限……',
    categories: ['hanman'],
    status: '连载',
    rating: 8.9,
    views: 4980000,
    updatedAt: '2026-08-01',
    chapters: [
      { id: 'ch-005-1', title: '第1话 转学第一天', number: 1, updatedAt: '2026-03-01' },
      { id: 'ch-005-2', title: '第2话 不该惹的人', number: 2, updatedAt: '2026-03-08' },
      { id: 'ch-005-3', title: '第3话 契约签订', number: 3, updatedAt: '2026-03-15' },
      { id: 'ch-005-4', title: '第4话 第一次约会', number: 4, updatedAt: '2026-03-22' },
      { id: 'ch-005-5', title: '第5话 危机来袭', number: 5, updatedAt: '2026-03-29' },
      { id: 'ch-005-6', title: '第6话 他的过去', number: 6, updatedAt: '2026-04-05' },
      { id: 'ch-005-7', title: '第7话 心动瞬间', number: 7, updatedAt: '2026-04-12' },
      { id: 'ch-005-8', title: '第8话 情敌出现', number: 8, updatedAt: '2026-04-19' },
      { id: 'ch-005-9', title: '第9话 误会', number: 9, updatedAt: '2026-04-26' },
      { id: 'ch-005-10', title: '第10话 雨中告白', number: 10, updatedAt: '2026-05-03' },
      { id: 'ch-005-11', title: '第11话 他的温柔', number: 11, updatedAt: '2026-05-10' },
      { id: 'ch-005-12', title: '第12话 契约到期', number: 12, updatedAt: '2026-05-17' },
      { id: 'ch-005-13', title: '第13话 真心', number: 13, updatedAt: '2026-05-24' },
      { id: 'ch-005-14', title: '第14话 重新开始', number: 14, updatedAt: '2026-05-31' },
      { id: 'ch-005-15', title: '第15话 甜蜜日常', number: 15, updatedAt: '2026-06-07' },
    ],
  },
  {
    id: 'comic-006',
    title: '一拳传说',
    author: '田中太郎',
    cover: 'https://readdy.ai/api/search-image?query=A%20action%20manga%20cover%20depicting%20a%20bald%20superhero%20with%20a%20powerful%20fist%20pose%2C%20dynamic%20action%20lines%2C%20explosive%20energy%20effects%2C%20clean%20bold%20anime%20art%20style%2C%20simple%20striking%20background%2C%20professional%20composition&width=400&height=560&seq=manga-cover-006&orientation=portrait',
    description: '普通上班族王大伟在一次意外中获得了"一拳无敌"的超能力——任何敌人都能被他一拳击败。但随着敌人越来越强，他开始怀疑这份力量的来源。隐藏在都市背后的超能力者世界，正在向他展开……',
    categories: ['riman'],
    status: '连载',
    rating: 9.3,
    views: 6280000,
    updatedAt: '2026-08-02',
    chapters: [
      { id: 'ch-006-1', title: '第1话 觉醒', number: 1, updatedAt: '2025-09-01' },
      { id: 'ch-006-2', title: '第2话 初战', number: 2, updatedAt: '2025-09-08' },
      { id: 'ch-006-3', title: '第3话 S级英雄', number: 3, updatedAt: '2025-09-15' },
      { id: 'ch-006-4', title: '第4话 英雄协会', number: 4, updatedAt: '2025-09-22' },
      { id: 'ch-006-5', title: '第5话 怪人入侵', number: 5, updatedAt: '2025-09-29' },
      { id: 'ch-006-6', title: '第6话 城市保卫战', number: 6, updatedAt: '2025-10-06' },
      { id: 'ch-006-7', title: '第7话 地下组织', number: 7, updatedAt: '2025-10-13' },
      { id: 'ch-006-8', title: '第8话 宿敌登场', number: 8, updatedAt: '2025-10-20' },
      { id: 'ch-006-9', title: '第9话 极限对决', number: 9, updatedAt: '2025-10-27' },
      { id: 'ch-006-10', title: '第10话 真相', number: 10, updatedAt: '2025-11-03' },
      { id: 'ch-006-11', title: '第11话 宇宙来客', number: 11, updatedAt: '2025-11-10' },
      { id: 'ch-006-12', title: '第12话 外星激战', number: 12, updatedAt: '2025-11-17' },
      { id: 'ch-006-13', title: '第13话 一拳终结', number: 13, updatedAt: '2025-11-24' },
      { id: 'ch-006-14', title: '第14话 和平日常', number: 14, updatedAt: '2025-12-01' },
      { id: 'ch-006-15', title: '第15话 新的威胁', number: 15, updatedAt: '2025-12-08' },
      { id: 'ch-006-16', title: '第16话 全球会议', number: 16, updatedAt: '2025-12-15' },
      { id: 'ch-006-17', title: '第17话 联合行动', number: 17, updatedAt: '2025-12-22' },
      { id: 'ch-006-18', title: '第18话 终极之战', number: 18, updatedAt: '2025-12-29' },
    ],
  },
  {
    id: 'comic-007',
    title: '狐妖小红娘',
    author: '小新',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20manhua%20cover%20featuring%20a%20cute%20fox%20spirit%20girl%20with%20orange%20ears%20and%20tail%20in%20traditional%20Chinese%20hanfu%2C%20romantic%20and%20mystical%20atmosphere%2C%20ancient%20Chinese%20aesthetic%2C%20clean%20manhua%20art%20style%2C%20soft%20warm%20background&width=400&height=560&seq=manga-cover-007&orientation=portrait',
    description: '在人妖共存的世界里，狐妖涂山苏苏以"红娘"为职业，为前世恋人们牵线搭桥。每一个故事都是一段跨越生死的深情，而她自己的前世，也隐藏着一段刻骨铭心的往事……',
    categories: ['guoman', 'wanjie'],
    status: '完结',
    rating: 9.6,
    views: 8900000,
    updatedAt: '2025-12-20',
    chapters: [
      { id: 'ch-007-1', title: '第1话 涂山苏苏', number: 1, updatedAt: '2024-01-01' },
      { id: 'ch-007-2', title: '第2话 第一桩姻缘', number: 2, updatedAt: '2024-01-08' },
      { id: 'ch-007-3', title: '第3话 前世今生', number: 3, updatedAt: '2024-01-15' },
      { id: 'ch-007-4', title: '第4话 月红篇', number: 4, updatedAt: '2024-01-22' },
      { id: 'ch-007-5', title: '第5话 王权篇', number: 5, updatedAt: '2024-01-29' },
      { id: 'ch-007-6', title: '第6话 竹业篇', number: 6, updatedAt: '2024-02-05' },
      { id: 'ch-007-7', title: '第7话 尾声篇', number: 7, updatedAt: '2024-02-12' },
      { id: 'ch-007-8', title: '第8话 金晨曦篇', number: 8, updatedAt: '2024-02-19' },
      { id: 'ch-007-9', title: '第9话 沐天城篇', number: 9, updatedAt: '2024-02-26' },
      { id: 'ch-007-10', title: '第10话 两生花篇', number: 10, updatedAt: '2024-03-04' },
      { id: 'ch-007-11', title: '第11话 无暮篇', number: 11, updatedAt: '2024-03-11' },
      { id: 'ch-007-12', title: '第12话 尾声（大结局）', number: 12, updatedAt: '2024-03-18' },
    ],
  },
  {
    id: 'comic-008',
    title: '重生之都市修仙',
    author: '百里玄策',
    cover: 'https://readdy.ai/api/search-image?query=A%20reincarnation%20manhua%20cover%20showing%20a%20young%20man%20with%20cultivation%20powers%20in%20modern%20urban%20setting%2C%20energy%20swirling%20around%20him%2C%20skyscrapers%20in%20background%2C%20dramatic%20lighting%2C%20clean%20manhua%20style%2C%20simple%20gradient%20background&width=400&height=560&seq=manga-cover-008&orientation=portrait',
    description: '修仙界合体期大能秦牧在渡天劫时陨落，却意外重生回到五百年前的少年时代。带着前世的记忆和功法，他要在这一世弥补所有遗憾，踏上真正的巅峰之路！',
    categories: ['guoman'],
    status: '连载',
    rating: 9.1,
    views: 7350000,
    updatedAt: '2026-08-03',
    chapters: [
      { id: 'ch-008-1', title: '第1话 陨落重生', number: 1, updatedAt: '2026-01-01' },
      { id: 'ch-008-2', title: '第2话 少年秦牧', number: 2, updatedAt: '2026-01-08' },
      { id: 'ch-008-3', title: '第3话 初露锋芒', number: 3, updatedAt: '2026-01-15' },
      { id: 'ch-008-4', title: '第4话 家族试炼', number: 4, updatedAt: '2026-01-22' },
      { id: 'ch-008-5', title: '第5话 一鸣惊人', number: 5, updatedAt: '2026-01-29' },
      { id: 'ch-008-6', title: '第6话 宗门来人', number: 6, updatedAt: '2026-02-05' },
      { id: 'ch-008-7', title: '第7话 入宗考核', number: 7, updatedAt: '2026-02-12' },
      { id: 'ch-008-8', title: '第8话 核心弟子', number: 8, updatedAt: '2026-02-19' },
      { id: 'ch-008-9', title: '第9话 秘境探险', number: 9, updatedAt: '2026-02-26' },
      { id: 'ch-008-10', title: '第10话 远古传承', number: 10, updatedAt: '2026-03-05' },
      { id: 'ch-008-11', title: '第11话 突破筑基', number: 11, updatedAt: '2026-03-12' },
      { id: 'ch-008-12', title: '第12话 宗门大比', number: 12, updatedAt: '2026-03-19' },
      { id: 'ch-008-13', title: '第13话 横扫强敌', number: 13, updatedAt: '2026-03-26' },
      { id: 'ch-008-14', title: '第14话 扬名天下', number: 14, updatedAt: '2026-04-02' },
      { id: 'ch-008-15', title: '第15话 魔道来袭', number: 15, updatedAt: '2026-04-09' },
    ],
  },
  {
    id: 'comic-009',
    title: '美食猎人',
    author: '高桥健一',
    cover: 'https://readdy.ai/api/search-image?query=A%20gourmet%20adventure%20manga%20cover%20showing%20a%20cheerful%20chef%20holding%20a%20giant%20fork%20and%20knife%20in%20a%20fantasy%20world%20full%20of%20giant%20food%2C%20colorful%20and%20vibrant%2C%20exciting%20adventure%20vibe%2C%20clean%20anime%20art%20style%2C%20simple%20warm%20background&width=400&height=560&seq=manga-cover-009&orientation=portrait',
    description: '在这个美食即是一切的世界里，少年食神东条明踏上了寻找传说中"终极食谱"的旅程。从深海巨兽到天空之岛，从沙漠绿洲到极寒之地，每一站都有令人垂涎的美食和惊险刺激的战斗在等待着他！',
    categories: ['riman', 'wanjie'],
    status: '完结',
    rating: 9.4,
    views: 4520000,
    updatedAt: '2026-05-10',
    chapters: [
      { id: 'ch-009-1', title: '第1话 美食世界', number: 1, updatedAt: '2025-03-01' },
      { id: 'ch-009-2', title: '第2话 出发！', number: 2, updatedAt: '2025-03-08' },
      { id: 'ch-009-3', title: '第3话 深海巨鲷', number: 3, updatedAt: '2025-03-15' },
      { id: 'ch-009-4', title: '第4话 天空鲸鱼', number: 4, updatedAt: '2025-03-22' },
      { id: 'ch-009-5', title: '第5话 沙漠蜜瓜', number: 5, updatedAt: '2025-03-29' },
      { id: 'ch-009-6', title: '第6话 冰原龙虾', number: 6, updatedAt: '2025-04-05' },
      { id: 'ch-009-7', title: '第7话 火山牛排', number: 7, updatedAt: '2025-04-12' },
      { id: 'ch-009-8', title: '第8话 美食协会', number: 8, updatedAt: '2025-04-19' },
      { id: 'ch-009-9', title: '第9话 黑暗料理界', number: 9, updatedAt: '2025-04-26' },
      { id: 'ch-009-10', title: '第10话 食神对决', number: 10, updatedAt: '2025-05-03' },
      { id: 'ch-009-11', title: '第11话 终极食谱', number: 11, updatedAt: '2025-05-10' },
      { id: 'ch-009-12', title: '第12话 最后的晚宴（大结局）', number: 12, updatedAt: '2025-05-17' },
    ],
  },
  {
    id: 'comic-010',
    title: '暗夜守护者',
    author: '朴志勋',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20manga%20cover%20showing%20a%20mysterious%20guardian%20in%20black%20armor%20with%20glowing%20eyes%20standing%20on%20a%20rooftop%20at%20night%2C%20moon%20in%20background%2C%20noir%20atmosphere%2C%20clean%20anime%20art%20style%2C%20simple%20dark%20gradient%20background&width=400&height=560&seq=manga-cover-010&orientation=portrait',
    description: '每当夜幕降临，城市便会出现一位神秘的"暗夜守护者"。他是普通人眼中的都市传说，却是罪犯心中的噩梦。记者苏晴在追踪报道中，逐渐揭开了守护者面具背后的惊人真相……',
    categories: ['hanman'],
    status: '连载',
    rating: 8.8,
    views: 3120000,
    updatedAt: '2026-08-01',
    chapters: [
      { id: 'ch-010-1', title: '第1话 暗夜传说', number: 1, updatedAt: '2026-04-01' },
      { id: 'ch-010-2', title: '第2话 记者苏晴', number: 2, updatedAt: '2026-04-08' },
      { id: 'ch-010-3', title: '第3话 第一次接触', number: 3, updatedAt: '2026-04-15' },
      { id: 'ch-010-4', title: '第4话 面具之下', number: 4, updatedAt: '2026-04-22' },
      { id: 'ch-010-5', title: '第5话 黑帮老大', number: 5, updatedAt: '2026-04-29' },
      { id: 'ch-010-6', title: '第6话 地下格斗', number: 6, updatedAt: '2026-05-06' },
      { id: 'ch-010-7', title: '第7话 生死追击', number: 7, updatedAt: '2026-05-13' },
      { id: 'ch-010-8', title: '第8话 真相碎片', number: 8, updatedAt: '2026-05-20' },
      { id: 'ch-010-9', title: '第9话 组织浮现', number: 9, updatedAt: '2026-05-27' },
      { id: 'ch-010-10', title: '第10话 父辈的罪', number: 10, updatedAt: '2026-06-03' },
    ],
  },
  {
    id: 'comic-011',
    title: '山海经异兽录',
    author: '墨韵',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20mythology%20manhua%20cover%20featuring%20various%20mythical%20beasts%20from%20Shan%20Hai%20Jing%2C%20a%20young%20adventurer%20with%20a%20compass%2C%20ancient%20Chinese%20aesthetic%2C%20ink%20wash%20painting%20style%2C%20mystical%20atmosphere%2C%20clean%20art%2C%20simple%20parchment%20background&width=400&height=560&seq=manga-cover-011&orientation=portrait',
    description: '考古系学生顾长安偶然获得了一本上古奇书《山海经》，书中记载的异兽竟然全部真实存在！他踏上了寻找散落各地异兽的旅程，一路上结识了各怀绝技的伙伴，也发现了隐藏在历史背后的惊天秘密。',
    categories: ['guoman'],
    status: '连载',
    rating: 9.3,
    views: 5670000,
    updatedAt: '2026-08-02',
    chapters: [
      { id: 'ch-011-1', title: '第1话 天书现世', number: 1, updatedAt: '2026-05-01' },
      { id: 'ch-011-2', title: '第2话 九尾狐踪', number: 2, updatedAt: '2026-05-08' },
      { id: 'ch-011-3', title: '第3话 青丘之山', number: 3, updatedAt: '2026-05-15' },
      { id: 'ch-011-4', title: '第4话 饕餮盛宴', number: 4, updatedAt: '2026-05-22' },
      { id: 'ch-011-5', title: '第5话 穷奇之乱', number: 5, updatedAt: '2026-05-29' },
      { id: 'ch-011-6', title: '第6话 昆仑虚', number: 6, updatedAt: '2026-06-05' },
      { id: 'ch-011-7', title: '第7话 西王母', number: 7, updatedAt: '2026-06-12' },
      { id: 'ch-011-8', title: '第8话 不死之药', number: 8, updatedAt: '2026-06-19' },
      { id: 'ch-011-9', title: '第9话 应龙降世', number: 9, updatedAt: '2026-06-26' },
      { id: 'ch-011-10', title: '第10话 四象归位', number: 10, updatedAt: '2026-07-03' },
    ],
  },
  {
    id: 'comic-012',
    title: '游戏人生',
    author: '榎宫祐',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20game%20world%20manga%20cover%20showing%20two%20siblings%20a%20boy%20and%20girl%20in%20a%20colorful%20fantasy%20game%20world%20full%20of%20magic%20and%20chess%20pieces%2C%20vibrant%20colors%2C%20clean%20anime%20art%20style%2C%20simple%20magical%20background&width=400&height=560&seq=manga-cover-012&orientation=portrait',
    description: '空与白是一对天才游戏玩家兄妹，他们在现实中是社交恐惧症患者，但在游戏世界中却是无人能敌的""（空白）。某天，他们被召唤到了一个一切由游戏决定的世界，在这里，他们要用游戏拯救人类种！',
    categories: ['riman', 'wanjie'],
    status: '完结',
    rating: 9.8,
    views: 10800000,
    updatedAt: '2025-08-15',
    chapters: [
      { id: 'ch-012-1', title: '第1话 游戏之神', number: 1, updatedAt: '2024-06-01' },
      { id: 'ch-012-2', title: '第2话 异世界', number: 2, updatedAt: '2024-06-08' },
      { id: 'ch-012-3', title: '第3话 人类种', number: 3, updatedAt: '2024-06-15' },
      { id: 'ch-012-4', title: '第4话 国王竞选', number: 4, updatedAt: '2024-06-22' },
      { id: 'ch-012-5', title: '第5话 与世界为敌', number: 5, updatedAt: '2024-06-29' },
      { id: 'ch-012-6', title: '第6话 兽人种', number: 6, updatedAt: '2024-07-06' },
      { id: 'ch-012-7', title: '第7话 天翼种', number: 7, updatedAt: '2024-07-13' },
      { id: 'ch-012-8', title: '第8话 神灵种', number: 8, updatedAt: '2024-07-20' },
      { id: 'ch-012-9', title: '第9话 最终游戏（大结局）', number: 9, updatedAt: '2024-07-27' },
    ],
  },
];

export const getComicsByCategory = (slug: string): Comic[] => {
  if (slug === 'wanjie') {
    return comics.filter(c => c.status === '完结');
  }
  return comics.filter(c => c.categories.includes(slug));
};

export const getComicById = (id: string): Comic | undefined => {
  return comics.find(c => c.id === id);
};

export const getFeaturedComics = (): Comic[] => {
  return comics.filter(c => c.featured);
};

export const getLatestComics = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
};

export const getPopularComics = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
};